import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.blog-post-content.rte img').forEach(function (img) {
    var w = img.getAttribute('width');
    var h = img.getAttribute('height');
    if (w) img.style.width  = /^\d+$/.test(w) ? w + 'px' : w;
    if (h) img.style.height = /^\d+$/.test(h) ? h + 'px' : h;
  });
});
